import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import axios from "axios";

import "./App.css";

import {
  baseUrl,
  subjectsUrl,
  subjects2Url,
} from "@/database/homePage/services.json";

import Industry1 from "@/assets/homePage/industry1.png";
import Industry2 from "@/assets/homePage/industry2.png";
import Industry3 from "@/assets/homePage/industry3.png";
import Industry4 from "@/assets/homePage/industry4.png";
import Traffic1 from "@/assets/homePage/traffic1.png";
import Traffic2 from "@/assets/homePage/traffic2.png";
import Traffic3 from "@/assets/homePage/traffic3.png";
import Traffic4 from "@/assets/homePage/traffic4.png";
import Chemistry1 from "@/assets/homePage/chemistry1.png";
import Chemistry2 from "@/assets/homePage/chemistry2.png";
import Chemistry3 from "@/assets/homePage/chemistry3.png";
import Chemistry4 from "@/assets/homePage/chemistry4.png";

import HomePage from "./components/homePage";
import SignUp from "./components/signUp";

class App extends Component {
  state = {
    enrollmentSubs: [],
    auditSubs: [],
    allSubs: [],
  };

  async componentDidMount() {
    //获取数据
    //获取普通科目的数据
    const { data: data1 } = await axios.get(baseUrl + subjectsUrl);
    //获取审核科目的数据
    const { data: data2 } = await axios.get(baseUrl + subjects2Url);

    //数据格式化
    //普通科目数据格式化
    const allSubs = [];
    const enrollmentSubs = [];
    data1.forEach((c) => {
      const subClass = {};
      subClass.title = c.title + "人员";
      const subs = [];
      c.children.forEach((s) => {
        const sub = {};
        sub.subName = s.title;
        sub.id = s.id;
        sub.is_sw = s.is_sw;
        sub.level = s.level;
        subs.push(sub);
      });
      subClass.subjects = subs;
      enrollmentSubs.push(subClass);
      allSubs.push(subClass);
    });
    //审核科目数据格式化
    const auditSubs = [];
    data2.forEach((c) => {
      if (c.title === "一般工贸") {
        const subClass = {};
        subClass.title = c.title + "人员";
        const subs = [];
        c.children.forEach((s, index) => {
          const sub = {};
          sub.subName = s.title;
          sub.id = s.id;
          sub.is_sw = s.is_sw;
          sub.level = s.level;
          sub.imgUrl = this.getGMImg(index);
          subs.push(sub);
        });
        subClass.subjects = subs;
        auditSubs.push(subClass);
        allSubs.push(subClass);
      } else if (c.title === "交通运输") {
        const subClass = {};
        subClass.title = c.title + "人员";
        const subs = [];
        c.children.forEach((s, index) => {
          const sub = {};
          sub.subName = s.title;
          sub.id = s.id;
          sub.is_sw = s.is_sw;
          sub.level = s.level;
          sub.imgUrl = this.getJTImg(index);
          subs.push(sub);
        });
        subClass.subjects = subs;
        auditSubs.push(subClass);
        allSubs.push(subClass);
      } else if (c.title === "职业卫生") {
        const subClass = {};
        subClass.title = c.title + "人员";
        const subs = [];
        c.children.forEach((s, index) => {
          const sub = {};
          sub.subName = s.title;
          sub.id = s.id;
          sub.is_sw = s.is_sw;
          sub.level = s.level;
          sub.imgUrl = this.getWSImg(index);
          subs.push(sub);
        });
        subClass.subjects = subs;
        auditSubs.push(subClass);
        allSubs.push(subClass);
      }
    });

    this.setState({ enrollmentSubs, auditSubs, allSubs });
  }

  getGMImg = (index) => {
    switch (Number(index)) {
      case 0:
        return Industry1;
      case 1:
        return Industry2;
      case 2:
        return Industry3;
      case 3:
        return Industry4;
      default:
        break;
    }
  };

  getJTImg = (index) => {
    switch (Number(index)) {
      case 0:
        return Traffic1;
      case 1:
        return Traffic2;
      case 2:
        return Traffic3;
      case 3:
        return Traffic4;
      default:
        break;
    }
  };

  getWSImg = (index) => {
    switch (Number(index)) {
      case 0:
        return Chemistry1;
      case 1:
        return Chemistry2;
      case 2:
        return Chemistry3;
      case 3:
        return Chemistry4;
      default:
        break;
    }
  };

  render() {
    const { enrollmentSubs, auditSubs, allSubs } = this.state;

    return (
      <div className="App">
        <Switch>
          <Route
            path="/signup/:id?"
            render={(props) => <SignUp allSubs={allSubs} {...props} />}
          ></Route>
          <Route
            path="/"
            render={(props) => (
              <HomePage
                enrollmentSubs={enrollmentSubs}
                auditSubs={auditSubs}
                {...props}
              />
            )}
          ></Route>
        </Switch>
      </div>
    );
  }
}

export default App;
